export default "__VITE_ASSET__Dfvhl0qc__"